module.exports = __webpack_public_path__ + "img/nature-2.8ce2625e.jpg";